import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { UntypedFormGroup } from '@angular/forms';

import { Validators } from '@angular/forms';
import { CourtBookingSaveFacade } from '../../+store/court-booking-save.facade';

@Component({
    selector: 'app-court-booking-save-players',
    templateUrl: './court-booking-save-players.component.html',
    styleUrls: ['./court-booking-save-players.component.scss'],
    standalone: false
})
export class CourtBookingSavePlayersComponent implements OnInit, OnDestroy {
    @Input() form: UntypedFormGroup;

    showTwoPlayers$ = this.courtBookingSaveFacade.showTwoPlayers$;
    showFourPlayers$ = this.courtBookingSaveFacade.showFourPlayers$;

    players$ = this.courtBookingSaveFacade.players$;

    categoryName$ = this.courtBookingSaveFacade.selectedCategoryName$;
    secondPlayerRules$ = this.courtBookingSaveFacade.secondPlayerRulesMatrix$;
    thirdPlayerRules$ = this.courtBookingSaveFacade.thirdPlayerRulesMatrix$;
    fourthPlayerRules$ = this.courtBookingSaveFacade.fourthPlayerRulesMatrix$;

    subscription: Subscription = new Subscription();
    constructor(private courtBookingSaveFacade: CourtBookingSaveFacade) { }

    ngOnInit(): void {
        this.subscription.add(
            this.showTwoPlayers$.subscribe(value => {
                if (value) {
                    this.form.controls.secondPlayer.setValidators([Validators.required]);
                } else {
                    this.form.controls.secondPlayer.setValidators(null);
                }
                this.form.controls.secondPlayer.updateValueAndValidity();
            })
        );
        this.subscription.add(
            this.showFourPlayers$.subscribe(value => {
                if (value) {
                    this.form.controls.secondPlayer.setValidators([Validators.required]);
                    this.form.controls.thirdPlayer.setValidators([Validators.required]);
                    this.form.controls.fourthPlayer.setValidators([Validators.required]);
                } else {
                    this.form.controls.secondPlayer.setValidators(null);
                    this.form.controls.thirdPlayer.setValidators(null);
                    this.form.controls.fourthPlayer.setValidators(null);
                }
                this.form.controls.secondPlayer.updateValueAndValidity();
                this.form.controls.thirdPlayer.updateValueAndValidity();
                this.form.controls.fourthPlayer.updateValueAndValidity();
            })
        );
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }
}
